<template>
    <div class="col-lg-12">
        <help-modal/>
        <incomplete-modal/>

        <div class="ibox form">
            <div class="ibox-title ibox-grey">
                <h4>{{ __('generating_transfer_lists') }}</h4>
                <button-open-help-modal :help-name="'ZPA-001'"/>
            </div>
        </div>

        <!-- PRZELEWY PL -->
        <div v-for="(list, list_index) in transfers.pl"
             v-if="hasTransfers(transfers.pl)" class="ibox form">
            <div class="ibox-content ibox-transfer">
                <list-header :currency="accountCurrency(list.account)"
                             :owner="accountOwner(list.account)"
                             :list="list"
                             :list_index="list_index"
                             :lists="listCount('pl')"
                             :optionsName="accountOptions(availableAccountsPl, 'name')"
                             :optionsNrb="accountOptions(availableAccountsPl, 'nrb')"
                             :today="today"
                             type="pl"
                             @addList="addList"
                             @confirmDatePicker="confirmDatePicker"
                             @removeList="removeList"
                             @setAccountName="setAccountName"
                />

                <div class="scroll-table table-transfers">
                    <div class="table-responsive text-nowrap">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th class="th-first">
                                    <input v-model="list.checked"
                                           type="checkbox"
                                           @input="changeListChecked($event, 'pl', list_index)">
                                </th>
                                <sortable-th :list="list" @setSort="setSort" label="payment_due_date_short" sort_col="due_date" />
                                <sortable-th :list="list" @setSort="setSort" label="amount" sort_col="amount" class="text-right" style="width:100px;" />
                                <sortable-th :list="list" @setSort="setSort" label="currency" sort_col="currency" />
                                <sortable-th :list="list" @setSort="setSort" label="contractor_data" sort_col="contractor_data" />
                                <sortable-th :list="list" @setSort="setSort" label="iban" sort_col="account_number" />
                                <sortable-th :list="list" @setSort="setSort" label="payment_name" sort_col="transfer_name" style="width:140px" />
                                <sortable-th :list="list" @setSort="setSort" label="split_payment_short" sort_col="split_payment" :wrap_label="true" style="width:55px;" />
                                <sortable-th :list="list" @setSort="setSort" label="vat_amount" sort_col="vat_amount" class="text-right" style="width:90px;" />
                                <sortable-th :list="list" @setSort="setSort" label="invoice_number" sort_col="document_number" label2="nip" sort_col2="id_number" style="width:110px;" />
                                <th class="th-before th-last" style="min-width:80px;"></th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr v-for="(transfer, transfer_index) in list.transfers"
                                :class="{'row-even': transfer_index % 2 === 0, 'row-odd': transfer_index % 2 !== 0 }"
                                :key="transfer_index"
                                class="row-one-line">
                                <td class="td-padding">
                                    <input v-model="transfer.checked"
                                           type="checkbox"
                                           @change="$nextTick(()=>rowCheckedChange('pl', list_index))">
                                </td>
                                <td class="td-padding">{{ transfer.due_date }}</td>
                                <td class="td-padding text-right">
                                    <amount-sources :transfer="transfer"/>
                                    <span v-if="transfer.amount == '0,00'" class="tittle-error help-block text-danger">Pole wymagane</span>

                                </td>
                                <td class="td-padding">{{ transfer.currency }}</td>
                                <td class="td-padding">
                                    <truncated-text :text="getContractorData(transfer.contractorState)" :max_length="20"/>
                                </td>

                                <td class="td-padding">
                                    <div class="input-group flex-nowrap">
                                        <select v-model="transfer.account_number" class="form-control nrb-select" name="account" @input="accountChanged($event.target.value, 'pl', list_index, transfer_index)">
                                            <option v-for="account in availableBankAccounts(transfer)">
                                                {{ account.account_number }}
                                            </option>
                                        </select>
                                        <div class="input-group-append">
                                            <span class="input-group-addon">
                                                <i :class="{'fa-check-circle': transfer.account_number_status === 'correct', 'fa-minus-circle': transfer.account_number_status === null }"
                                                   :data-original-title="__(getTitleFromStatus(transfer.account_number_status))"
                                                   class="fas text-info"
                                                   data-placement="top"
                                                   data-toggle="tooltip"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <span v-if="transfer.account_number_status == 'deleted'" class="tittle-error help-block text-danger">Pole wymagane</span>
                                </td>
                                <td class="td-padding"><input v-model="transfer.transfer_name" class="form-control" style="width:140px;"
                                                              type="text">

                                    <span v-if="transfer.transfer_name == ''" class="tittle-error help-block text-danger">Pole wymagane</span></td>
                                <td class="td-padding"><input v-model="transfer.split_payment" checked type="checkbox">
                                </td>
                                <td class="td-padding text-right">
                                    <input v-if="transfer.split_payment"
                                           v-model="transfer.vat_amount"
                                           @change="formattedVatAmount(transfer)"
                                           class="form-control text-right"
                                           style="width:80px;"
                                           type="text">
                                    <span v-if="(transfer.vat_amount == '0,00' && transfer.split_payment) || (transfer.split_payment && transfer.vat_amount == 0)" class="tittle-error help-block text-danger">Pole wymagane</span>
                                </td>
                                <!-- numer faktury i NIP w dwoch wierszach -->
                                <td class="td-padding">
                                    <template v-if="transfer.split_payment">
                                        <truncated-text :text="transfer.document_number || ''" :max_length="20"/>
                                        <br>
                                        <span v-if="idNotAllowed(transfer)" class="text-danger">{{ __('fill_nip') }}</span>
                                        <span v-else>{{ transfer.id_number }}</span>
                                    </template>
                                </td>
                                <row-icons
                                    :list_index="list_index" :transfer="transfer"
                                    :transfer_index="transfer_index" list_type="pl"
                                    @downloadLink="downloadLink"
                                    @editContractor="editContractor"
                                    @movedown="movedown"
                                    @moveup="moveup"
                                />
                            </tr>
                            <!-- podsumowanie boxu: CAŁA LISTA + suma kwot -->
                            <tr class="row-sum">
                                <td class="td-padding"></td>
                                <td class="td-padding"><strong>{{ __('whole_list') }}:</strong></td>
                                <td class="td-padding text-right"><strong>{{ listAmountSum(list) | money }}</strong></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- PRZELEWY PL TAX -->
        <div v-for="(list, list_index) in transfers.pl_tax"
            v-if="hasTransfers(transfers.pl_tax)" class="ibox form">
            <div class="ibox-content ibox-transfer">
                <list-header :currency="accountCurrency(list.account)"
                             :owner="accountOwner(list.account)"
                             :list="list"
                             :list_index="list_index"
                             :lists="listCount('pl_tax')"
                             :optionsName="accountOptions(availableAccountsPl, 'name')"
                             :optionsNrb="accountOptions(availableAccountsPl, 'nrb')"
                             :today="today"
                             type="pl_tax"
                             @addList="addList"
                             @confirmDatePicker="confirmDatePicker"
                             @removeList="removeList"
                             @setAccountName="setAccountName"
                />

                <div class="scroll-table table-transfers">
                    <div class="table-responsive text-nowrap">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th class="th-first">
                                    <input v-model="list.checked"
                                           type="checkbox"
                                           @input="changeListChecked($event, 'pl_tax', list_index)">
                                </th>
                                <sortable-th :list="list" @setSort="setSort" label="payment_due_date_short" sort_col="due_date" />
                                <sortable-th :list="list" @setSort="setSort" label="amount" sort_col="amount" class="text-right" style="width:90px;" />
                                <sortable-th :list="list" @setSort="setSort" label="currency" sort_col="currency" />
                                <sortable-th :list="list" @setSort="setSort" label="contractor_data" sort_col="contractor_data" />
                                <sortable-th :list="list" @setSort="setSort" label="iban" sort_col="account_number" />
                                <sortable-th :list="list" @setSort="setSort" label="form_symbol_short" sort_col="form_symbol" label2="period" sort_col2="period" style="width:110px" />
                                <sortable-th :list="list" @setSort="setSort" label="liability_id" sort_col="liability_id" style="width:80px" />
                                <sortable-th :list="list" @setSort="setSort" label="payer_data" sort_col="payer_data" label2="payer_identificator" sort_col2="payer_identificator" style="width:160px" />
                                <th class="th-before th-last" style="min-width:80px;"></th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr v-for="(transfer, transfer_index) in list.transfers"
                                :class="{'row-even': transfer_index % 2 === 0, 'row-odd': transfer_index % 2 !== 0 }"
                                class="row-one-line">
                                <td class="td-padding">
                                    <input v-model="transfer.checked"
                                           type="checkbox"
                                           @change="$nextTick(()=>rowCheckedChange('pl_tax', list_index))">
                                </td>
                                <td class="td-padding">{{ transfer.due_date }}</td>
                                <td class="td-padding text-right">
                                    <amount-sources :transfer="transfer"/>
                                    <span v-if="transfer.amount == '0,00'" class="tittle-error help-block text-danger">Pole wymagane</span>
                                </td>
                                <td class="td-padding">{{ transfer.currency }}</td>
                                <td class="td-padding">
                                    <truncated-text :text="getContractorData(transfer.contractorState)" :max_length="20"/>
                                </td>

                                <td class="td-padding">
                                    <div class="input-group flex-nowrap">
                                        <select v-model="transfer.account_number" class="form-control nrb-select" name="account" @input="accountChanged($event.target.value, 'pl_tax', list_index, transfer_index)">
                                            <option v-for="account in availableBankAccounts(transfer)">
                                                {{ account.account_number }}
                                            </option>
                                        </select>
                                        <div class="input-group-append">
                                            <span class="input-group-addon">
                                                <i :class="{'fa-check-circle': transfer.account_number_status === 'correct', 'fa-minus-circle': transfer.account_number_status === null }"
                                                   :data-original-title="__(getTitleFromStatus(transfer.account_number_status))"
                                                   class="fas text-info"
                                                   data-placement="top"
                                                   data-toggle="tooltip"></i>
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <!-- symbol formularza i okres w dwoch wierszach -->
                                <td class="td-padding">
                                    {{ __(transfer.pl_tax_data.symbol) }}<br>{{ getFullPeriod(transfer.pl_tax_data) }}
                                </td>
                                <td class="td-padding">
                                    <truncated-text :text="__(transfer.pl_tax_data.period_identification_title)" :max_length="20"/>
                                </td>
                                <!-- dane i identyfikator platnika w dwoch wierszach -->
                                <td class="td-padding">
                                    <truncated-text :text="getPlTaxName(transfer.pl_tax_data)" :max_length="25"/>
                                    <br>{{ getFullPlTaxID(transfer.pl_tax_data) }}
                                </td>
                                <row-icons
                                    :list_index="list_index" :transfer="transfer"
                                    :transfer_index="transfer_index" list_type="pl_tax"
                                    @downloadLink="downloadLink"
                                    @editContractor="editContractor"
                                    @movedown="movedown"
                                    @moveup="moveup"
                                />
                            </tr>
                            <!-- podsumowanie boxu: CAŁA LISTA + suma kwot -->
                            <tr class="row-sum">
                                <td class="td-padding"></td>
                                <td class="td-padding"><strong>{{ __('whole_list') }}:</strong></td>
                                <td class="td-padding text-right"><strong>{{ listAmountSum(list) | money }}</strong></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- IBAN SEPA -->
        <div v-for="(list, list_index) in transfers.iban_sepa"
             v-if="hasTransfers(transfers.iban_sepa)" class="ibox form">
            <div class="ibox-content ibox-transfer">
                <list-header :currency="accountCurrency(list.account)"
                             :owner="accountOwner(list.account)"
                             :list="list"
                             :list_index="list_index"
                             :lists="listCount('iban_sepa')"
                             :optionsName="accountOptions(availableAccounts, 'name')"
                             :optionsNrb="accountOptions(availableAccounts, 'nrb')"
                             :chargeOptionsName="chargeAccountOptions(list, 'name')"
                             :chargeOptionsNrb="chargeAccountOptions(list, 'nrb')"
                             :chargeCurrency="accountCurrency(list.charge_payment_source_id)"
                             :today="today"
                             type="iban_sepa"
                             @addList="addList"
                             @confirmDatePicker="confirmDatePicker"
                             @removeList="removeList"
                             @setAccountName="setAccountName"
                             @setChargeAccount="setChargeAccount"
                />

                <div class="scroll-table table-transfers">
                    <div class="table-responsive text-nowrap">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th class="th-first">
                                    <input v-model="list.checked"
                                           type="checkbox"
                                           @input="changeListChecked($event, 'iban_sepa', list_index)">
                                </th>
                                <sortable-th :list="list" @setSort="setSort" label="payment_due_date_short" sort_col="due_date" />
                                <sortable-th :list="list" @setSort="setSort" label="amount" sort_col="amount" class="text-right" style="width:90px;" />
                                <sortable-th :list="list" @setSort="setSort" label="currency" sort_col="currency" />
                                <sortable-th :list="list" @setSort="setSort" label="contractor_data" sort_col="contractor_data" />
                                <sortable-th :list="list" @setSort="setSort" label="iban" sort_col="account_number" />
                                <sortable-th :list="list" @setSort="setSort" label="BIC/SWIFT" sort_col="swift" style="width:100px" />
                                <sortable-th :list="list" @setSort="setSort" label="bank_name2" sort_col="bank_name" style="width:140px" />
                                <sortable-th :list="list" @setSort="setSort" label="payment_name" sort_col="transfer_name" style="width:140px" />
                                <th class="th-before th-last" style="min-width:80px;"></th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr v-for="(transfer, transfer_index) in list.transfers"
                                :class="{'row-even': transfer_index % 2 === 0, 'row-odd': transfer_index % 2 !== 0 }"
                                class="row-one-line">
                                <td class="td-padding">
                                    <input v-model="transfer.checked"
                                           type="checkbox"
                                           @change="$nextTick(()=>rowCheckedChange('iban_sepa', list_index))">
                                </td>
                                <td class="td-padding">{{ transfer.due_date }}</td>
                                <td class="td-padding text-right">
                                    <amount-sources :transfer="transfer"/>
                                    <span v-if="transfer.amount == '0,00'" class="tittle-error help-block text-danger">Pole wymagane</span>
                                </td>
                                <td class="td-padding">{{ transfer.currency }}</td>
                                <td class="td-padding">
                                    <truncated-text :text="getContractorData(transfer.contractorState, true)" :max_length="20"/>
                                </td>

                                <td class="td-padding">
                                    <div class="input-group">
                                        <select v-model="transfer.account_number" class="form-control" name="account" @input="accountChanged($event.target.value, 'iban_sepa', list_index, transfer_index)">
                                            <option v-for="account in availableBankAccounts(transfer)">
                                                {{ account.account_number }}
                                            </option>
                                        </select>
                                        <div class="input-group-append">
                                            <span class="input-group-addon">
                                                <i :class="{'fa-check-circle': transfer.account_number_status === 'correct', 'fa-minus-circle': transfer.account_number_status === null }"
                                                   :data-original-title="__(getTitleFromStatus(transfer.account_number_status))"
                                                   class="fas text-info"
                                                   data-placement="top"
                                                   data-toggle="tooltip"></i>
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td class="td-padding"><input v-model="transfer.swift" class="form-control" disabled
                                                              style="width:100px;" type="text"></td>
                                <td class="td-padding">
                                    <truncated-text :text="transfer.bank_name" :max_length="20"/>
                                </td>
                                <td class="td-padding"><input v-model="transfer.transfer_name" class="form-control" style="width:140px;"
                                                              type="text">
                                    <span v-if="transfer.transfer_name == ''" class="tittle-error help-block text-danger">Pole wymagane</span></td>
                                <row-icons
                                    :list_index="list_index" :transfer="transfer"
                                    :transfer_index="transfer_index" list_type="iban_sepa"
                                    @downloadLink="downloadLink"
                                    @editContractor="editContractor"
                                    @movedown="movedown"
                                    @moveup="moveup"
                                />
                            </tr>
                            <!-- podsumowanie boxu: CAŁA LISTA + suma kwot -->
                            <tr class="row-sum">
                                <td class="td-padding"></td>
                                <td class="td-padding"><strong>{{ __('whole_list') }}:</strong></td>
                                <td class="td-padding text-right"><strong>{{ listAmountSum(list) | money }}</strong></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>

        <!-- IBAN SWIFT -->
        <div v-for="(list, list_index) in transfers.iban_swift"
             v-if="hasTransfers(transfers.iban_swift)" class="ibox form">
            <div class="ibox-content ibox-transfer">
                <list-header :currency="accountCurrency(list.account)"
                             :owner="accountOwner(list.account)"
                             :list="list"
                             :list_index="list_index"
                             :lists="listCount('iban_swift')"
                             :optionsName="accountOptions(availableAccounts, 'name')"
                             :optionsNrb="accountOptions(availableAccounts, 'nrb')"
                             :chargeOptionsName="chargeAccountOptions(list, 'name')"
                             :chargeOptionsNrb="chargeAccountOptions(list, 'nrb')"
                             :chargeCurrency="accountCurrency(list.charge_payment_source_id)"
                             :today="today"
                             type="iban_swift"
                             @addList="addList"
                             @confirmDatePicker="confirmDatePicker"
                             @removeList="removeList"
                             @setAccountName="setAccountName"
                             @setChargeAccount="setChargeAccount"
                />

                <div class="scroll-table table-transfers">
                    <div class="table-responsive text-nowrap">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th class="th-first">
                                    <input v-model="list.checked"
                                           type="checkbox"
                                           @input="changeListChecked($event, 'iban_swift', list_index)">
                                </th>
                                <sortable-th :list="list" @setSort="setSort" label="payment_due_date_short" sort_col="due_date" />
                                <sortable-th :list="list" @setSort="setSort" label="amount" sort_col="amount" class="text-right" style="width:90px;" />
                                <sortable-th :list="list" @setSort="setSort" label="currency" sort_col="currency" />
                                <sortable-th :list="list" @setSort="setSort" label="contractor_data" sort_col="contractor_data" />
                                <sortable-th :list="list" @setSort="setSort" label="iban" sort_col="account_number" />
                                <sortable-th :list="list" @setSort="setSort" label="BIC/SWIFT" sort_col="swift" style="width:100px" />
                                <sortable-th :list="list" @setSort="setSort" label="bank_name2" sort_col="bank_name" style="width:140px" />
                                <sortable-th :list="list" @setSort="setSort" label="payment_name" sort_col="transfer_name" style="width:140px" />
                                <th class="th-before th-last" style="min-width:80px;"></th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr v-for="(transfer, transfer_index) in list.transfers"
                                :class="{'row-even': transfer_index % 2 === 0, 'row-odd': transfer_index % 2 !== 0 }"
                                class="row-one-line">
                                <td class="td-padding">
                                    <input v-model="transfer.checked"
                                           type="checkbox"
                                           @change="$nextTick(()=>rowCheckedChange('iban_swift', list_index))">
                                </td>
                                <td class="td-padding">{{ transfer.due_date }}</td>
                                <td class="td-padding text-right">
                                    <amount-sources :transfer="transfer"/>
                                    <span v-if="transfer.amount == '0,00'" class="tittle-error help-block text-danger">Pole wymagane</span>
                                </td>
                                <td class="td-padding">{{ transfer.currency }}</td>
                                <td class="td-padding">
                                    <truncated-text :text="getContractorData(transfer.contractorState, true)" :max_length="20"/>
                                </td>

                                <td class="td-padding">
                                    <div class="input-group">
                                        <select v-model="transfer.account_number" class="form-control" name="account" @input="accountChanged($event.target.value, 'iban_swift', list_index, transfer_index)">
                                            <option v-for="account in availableBankAccounts(transfer)">
                                                {{ account.account_number }}
                                            </option>
                                        </select>
                                        <div class="input-group-append">
                                            <span class="input-group-addon">
                                                <i :class="{'fa-check-circle': transfer.account_number_status === 'correct', 'fa-minus-circle': transfer.account_number_status === null }"
                                                   :data-original-title="__(getTitleFromStatus(transfer.account_number_status))"
                                                   class="fas text-info"
                                                   data-placement="top"
                                                   data-toggle="tooltip"></i>
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td class="td-padding"><input v-model="transfer.swift" class="form-control" disabled
                                                              style="width:100px;" type="text"></td>
                                <td class="td-padding">
                                    <truncated-text :text="transfer.bank_name" :max_length="20"/>
                                </td>
                                <td class="td-padding"><input v-model="transfer.transfer_name" class="form-control" style="width:140px;"
                                                              type="text">
                                    <span v-if="transfer.transfer_name == ''" class="tittle-error help-block text-danger">Pole wymagane</span></td>
                                <row-icons
                                    :list_index="list_index" :transfer="transfer"
                                    :transfer_index="transfer_index" list_type="iban_swift"
                                    @downloadLink="downloadLink"
                                    @editContractor="editContractor"
                                    @movedown="movedown"
                                    @moveup="moveup"
                                />
                            </tr>
                            <!-- podsumowanie boxu: CAŁA LISTA + suma kwot -->
                            <tr class="row-sum">
                                <td class="td-padding"></td>
                                <td class="td-padding"><strong>{{ __('whole_list') }}:</strong></td>
                                <td class="td-padding text-right"><strong>{{ listAmountSum(list) | money }}</strong></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>

        <!-- INNE PRZELEWY -->
        <div v-for="(list, list_index) in transfers.other"
             v-if="hasTransfers(transfers.other)" class="ibox form">
            <div class="ibox-content ibox-transfer">
                <list-header :currency="accountCurrency(list.account)"
                             :owner="accountOwner(list.account)"
                             :list="list"
                             :list_index="list_index"
                             :lists="listCount('other')"
                             :optionsName="accountOptions(availableAccounts, 'name')"
                             :optionsNrb="accountOptions(availableAccounts, 'nrb')"
                             :today="today"
                             type="other"
                             @addList="addList"
                             @confirmDatePicker="confirmDatePicker"
                             @removeList="removeList"
                             @setAccountName="setAccountName"
                />

                <div class="scroll-table table-transfers">
                    <div class="table-responsive text-nowrap">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th class="th-first">
                                    <input v-model="list.checked"
                                           type="checkbox"
                                           @input="changeListChecked($event, 'other', list_index)">
                                </th>
                                <sortable-th :list="list" @setSort="setSort" label="payment_due_date_short" sort_col="due_date" />
                                <sortable-th :list="list" @setSort="setSort" label="amount" sort_col="amount" class="text-right" style="width:90px;" />
                                <sortable-th :list="list" @setSort="setSort" label="currency" sort_col="currency" />
                                <sortable-th :list="list" @setSort="setSort" label="contractor_data" sort_col="contractor_data" />
                                <sortable-th :list="list" @setSort="setSort" label="iban" sort_col="account_number" />
                                <th style="width:350px">{{ __('other_transfer_data') }}</th>
                                <sortable-th :list="list" @setSort="setSort" label="payment_name" sort_col="transfer_name" style="width:140px" />
                                <th class="th-before th-last" style="min-width:80px;"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(transfer, transfer_index) in list.transfers"
                                :class="{'row-even': transfer_index % 2 === 0, 'row-odd': transfer_index % 2 !== 0 }"
                                class="row-one-line">
                                <td class="td-padding">
                                    <input v-model="transfer.checked"
                                           type="checkbox"
                                           @change="$nextTick(()=>rowCheckedChange('other', list_index))">
                                </td>
                                <td class="td-padding">{{ transfer.due_date }}</td>
                                <td class="td-padding text-right">
                                    <amount-sources :transfer="transfer"/>
                                    <span v-if="transfer.amount == '0,00'" class="tittle-error help-block text-danger">Pole wymagane</span>
                                </td>
                                <td class="td-padding">{{ transfer.currency }}</td>
                                <td class="td-padding">
                                    <truncated-text :text="getContractorData(transfer.contractorState, true)" :max_length="20"/>
                                </td>
                                <td class="td-padding">
                                    <div class="input-group">
                                        <select v-model="transfer.account_number" class="form-control" name="account" @input="accountChanged($event.target.value, 'other', list_index, transfer_index)">
                                            <option v-for="account in availableBankAccounts(transfer)">
                                                {{ account.account_number }}
                                            </option>
                                        </select>
                                        <div class="input-group-append">
                                            <span class="input-group-addon">
                                                <i :class="{'fa-check-circle': transfer.account_number_status === 'correct', 'fa-minus-circle': transfer.account_number_status === null }"
                                                   :data-original-title="__(getTitleFromStatus(transfer.account_number_status))"
                                                   class="fas text-info"
                                                   data-placement="top"
                                                   data-toggle="tooltip"></i>
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td class="td-padding">{{ transfer.other_transfer_data }}</td>
                                <td class="td-padding"><input v-model="transfer.transfer_name" class="form-control" style="width:140px;"
                                                              type="text">
                                    <span v-if="transfer.transfer_name == ''" class="tittle-error help-block text-danger">Pole wymagane</span></td>
                                <row-icons
                                    :list_index="list_index" :transfer="transfer"
                                    :transfer_index="transfer_index" list_type="other"
                                    @downloadLink="downloadLink"
                                    @editContractor="editContractor"
                                    @movedown="movedown"
                                    @moveup="moveup"
                                />
                            </tr>
                            <!-- podsumowanie boxu: CAŁA LISTA + suma kwot -->
                            <tr class="row-sum">
                                <td class="td-padding"></td>
                                <td class="td-padding"><strong>{{ __('whole_list') }}:</strong></td>
                                <td class="td-padding text-right"><strong>{{ listAmountSum(list) | money }}</strong></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>


        <!-- POZOSTAŁE PRZELEWY -->
        <div v-for="(list, list_index) in transfers.rest" class="ibox form">
            <div class="ibox-content ibox-transfer">
                <div class="form-group row-grey row m-b-sm align-items-center">
                    <div class="col-md-auto">
                        <h4>{{ __('transfers_rest') }}</h4>
                    </div>
                </div>

                <div class="scroll-table table-transfers">
                    <div class="table-responsive text-nowrap">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <sortable-th :list="list" @setSort="setSort" label="payment_due_date_short" sort_col="due_date" class="th-first" />
                                <sortable-th :list="list" @setSort="setSort" label="amount" sort_col="amount" class="text-right" style="width:90px;" />
                                <sortable-th :list="list" @setSort="setSort" label="currency" sort_col="currency" />
                                <sortable-th :list="list" @setSort="setSort" label="contractor_data" sort_col="contractor_data" />
                                <sortable-th :list="list" @setSort="setSort" label="iban" sort_col="account_number" />
                                <sortable-th :list="list" @setSort="setSort" label="payment_name" sort_col="transfer_name" style="width:140px" />
                                <th class="th-before th-last"></th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr v-for="(transfer, transfer_index) in list.transfers" class="row-odd row-one-line">
                                <td class="td-padding">{{ transfer.due_date }}</td>
                                <td class="td-padding text-right">{{ transfer.amount | money }}</td>
                                <td class="td-padding">{{ transfer.currency }}</td>
                                <td class="td-padding">
                                    <truncated-text :text="getContractorData(transfer.contractorState, true)" :max_length="20"/>
                                </td>
                                <td class="td-padding">{{ transfer.account_number }}</td>
                                <td class="td-padding">{{ transfer.transfer_name }}</td>
                                <row-icons
                                    :list_index="list_index" :transfer="transfer"
                                    :transfer_index="transfer_index" list_type="rest"
                                    @downloadLink="downloadLink"
                                    @editContractor="editContractor"
                                    @movedown="movedown"
                                    @moveup="moveup"
                                />
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>


            </div>
        </div>

        <!-- PRZYCISKI -->
        <div class="ibox-content">
            <div class="row">
                <div class="col-6">
                    <button :disabled="combineDisabled" class="btn btn-primary btn-sm"
                            type="button"
                            @click="combineSelected">{{ __('combine_transfers') }}</button>
                </div>
                <div class="col-6 text-right">
                    <button :disabled="saveDisabled" class="btn btn-primary btn-sm" type="button" @click="saveLists">{{ __('save_lists') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import actions from "../../vuex/action_types.js";
import mutation_types from "../../vuex/generate_transfer_list/mutation_types.js";
import {Money} from "../../services/Money";
import Swal from "sweetalert2";

export default {
    name: "GenerateTransferList",
    props: [
        'toDate',
        'paymentSources',
        'today',
        'contractor_id',
        'new_contractor',
        'allowed_id_number_types',
        'ksef_connection_params_saved'
    ],
    data: () => {
        return {
            availableAccounts: [],
            allowed_id_numbers: [],
            money: new Money(),
            transfers: {
                pl: [],
                pl_tax: [],
                iban_swift: [],
                iban_sepa: [],
                other: [],
                rest: []
            }
        }
    },
    methods: {
        //suma kwot całej listy - wiersz CAŁA LISTA na dole boxu
        listAmountSum(list) {
            let sum = 0;

            for (let transfer of list.transfers) {
                let amount = this.money.toFloat(transfer.amount);

                if (!isNaN(amount)) {
                    sum += amount;
                }
            }

            return sum;
        },
        formattedVatAmount(transfer) {
            var amount = this.money.toFloat(transfer.vat_amount);
            if(amount < 0 || isNaN(this.money.toFloat(transfer.vat_amount))){
                amount = 0;
            }
            transfer.vat_amount=  this.money.localize(this.money.toFloat(amount));

        },
        isPlIbanAccount: function (account_number) {
            return (account_number || '').replace(/\s/g, '').toUpperCase().startsWith('PL');
        },
        //szablon IBAN rozklada sie na 3 boxy: PL (platnosci w PLN na rachunki IBAN zaczynajace sie od PL),
        //IBAN-SEPA (platnosci w EURO) oraz IBAN-SWIFT (pozostale)
        ibanListType: function (transfer) {
            if (transfer.currency === 'PLN' && this.isPlIbanAccount(transfer.account_number)) return 'pl';
            if (transfer.currency === 'EUR') return 'iban_sepa';

            return 'iban_swift';
        },
        //box, do ktorego przelew nalezy wg szablonu rachunku, waluty i numeru rachunku
        targetListType: function (transfer) {
            switch (transfer.transfer_type) {
                case 'pl':
                    return 'pl';
                case 'pl-tax':
                    return 'pl_tax';
                case 'iban':
                    return this.ibanListType(transfer);
                default:
                    return 'other';
            }
        },
        //dla walut innych niz PLN przelew moze isc wylacznie z rachunku szablonu IBAN
        availableBankAccounts: function (transfer) {
            if (transfer.currency === 'PLN') return transfer.bank_accounts;

            return transfer.bank_accounts.filter(account => account.account_type === 'iban');
        },
        siftTransfers: function (transfers) {
            for (let transfer of transfers) {
                transfer.checked = false;
                transfer.other_transfer_data = '';

                if (transfer.due_date > this.toDate) {
                    this.transfers.rest[0].transfers.push(transfer);
                    continue;
                }

                this.transfers[this.targetListType(transfer)][0].transfers.push(transfer);
            }

            this.sortLists();
        },
        emptyList: function () {
            return {
                account: null,
                account_name: null,
                account_number: null,
                //ostatnio ustawiony rachunek - do wykrycia realnej zmiany rachunku
                account_selected_id: null,
                checked: false,
                due_date: null,
                description: null,
                //rachunek do opłat (listy IBAN-SEPA oraz IBAN-SWIFT)
                charge_payment_source_id: null,
                charge_bearer: 'sha',
                errors: {
                    account: false,
                    due_date: false,
                    description: false
                },
                transfers: [],
                sort_col: 'contractor_data',
                sort_dir: 'asc'
            };
        },
        setAccountName: function (account_id, list) {
            let id = parseInt(account_id);
            let account = this.availableAccounts.find(acc => acc.id === id);

            if (!account) return;

            //oba pola rachunku (nazwa i NRB) zgłaszają wybór także wtedy, gdy wskazany
            //rachunek się nie zmienił - wiersz opłat czyścimy tylko przy realnej zmianie
            let accountChanged = list.account_selected_id !== id;

            list.account_selected_id = id;
            list.account_name = account.name;
            list.account_number = account.details.nrb;

            if (accountChanged) {
                this.resetChargeAccount(list);
            }
        },
        resetChargeAccount: function (list) {
            list.charge_payment_source_id = null;
            list.charge_bearer = 'sha';
        },
        setChargeAccount: function (account_id, list) {
            let id = parseInt(account_id);

            list.charge_payment_source_id = id > 0 ? id : null;

            //koszty opłat resetują się razem z rachunkiem do opłat - sama zmiana rachunku
            //na inny zostawia wybraną wcześniej opcję
            if (list.charge_payment_source_id === null) {
                list.charge_bearer = 'sha';
            }
        },
        //rachunek do opłat wybieramy spośród rachunków dostępnych na liście powyżej
        //(pozycja "inny rachunek" o id -1 nie jest realnym źródłem płatności),
        //należących do tego samego właściciela co rachunek wybrany powyżej
        chargeAccounts: function (list) {
            let id = parseInt(list.account);

            if (id <= 0) return [];

            let selected = this.availableAccounts.find(acc => acc.id === id);

            if (!selected) return [];

            let owner_id = selected.instance_information_company_id || null;

            return this.availableAccounts.filter(acc =>
                acc.id !== -1 && (acc.instance_information_company_id || null) === owner_id
            );
        },
        chargeAccountOptions: function (list, display) {
            //pole domyślnie niewypełnione - pusta pozycja na początku listy
            return [{id: 0, text: ''}].concat(this.accountOptions(this.chargeAccounts(list), display));
        },
        accountCurrency: function (id) {
            let selected_account_array = this.availableAccounts.filter((acc) => {
                return acc.id === parseInt(id);
            });

            if (selected_account_array.length) {
                let selected_account = selected_account_array[0];

                return selected_account.currency;
            }

            return null;
        },
        accountOwner: function (id) {
            let selected_account_array = this.availableAccounts.filter((acc) => {
                return acc.id === parseInt(id);
            });

            if (selected_account_array.length) {
                let selected_account = selected_account_array[0];

                return selected_account.owner;
            }

            return null;
        },
        accountOptions: function (options, display) {
            return options.filter((option) =>
                (option.id === -1 && display === 'nrb') !== true
            ).map((option) => {
                return {
                    text: display === 'nrb' ? option.details.nrb : option.name,
                    id: option.id
                }
            })
        },
        getFullPeriod: function (data) {
            switch (data.period) {
                case 'R':
                    return this.__('year') + ': ' + data.period_year;
                case 'P':
                    return this.__('half_year') + ': ' + data.period_half_year + ', '
                        + this.__('year') + ': ' + data.period_year;
                case 'K':
                    return this.__('quarter') + ': ' + data.period_quarter + ', '
                        + this.__('year') + ': ' + data.period_year;
                case 'M':
                    return this.__('month') + ': ' + data.period_month + ', '
                        + this.__('year') + ': ' + data.period_year;
                case 'D':
                    return this.__('decade') + ': ' + data.period_decade + ', '
                        + this.__('month') + ': ' + data.period_month + ', '
                        + this.__('year') + ': ' + data.period_year;
                case 'J':
                    return this.__('day') + ': ' + data.period_day;
                // kolumna "Typ okresu" zostala usunieta - bez tego okres "O" bylby pusty
                case 'O':
                    return this.__('not_assigned_to_any_period_short');
            }
        },
        getFullPlTaxID: function (data) {
            let name;
            switch (data.identification_number_type) {
                case 'N':
                    name = 'N - NIP';
                    break;
                case 'R':
                    name = 'R - REGON'
                    break;
                case 'P':
                    name = 'P - PESEL'
                    break;
                case '1':
                    name = this.__('id_card')
                    break;
                case '2':
                    name = this.__('passport')
                    break;
            }
            if(data.identification_number_type == '1'){
                return '1' + ' - '+ this.__('id_card') +': ' + data.identification_number;
            }
            else if(data.identification_number_type == '2')
            {
                return '2' + ' - '+ this.__('passport')+': ' + data.identification_number
            }
            else{
                return name + ': ' + data.identification_number;
            }

        },
        moveup: function (list_type, list_index, transfer_index) {
            if (!this.transfers[list_type]) return;

            if (list_type !== 'rest') {
                let transfer = this.transfers[list_type][list_index].transfers[transfer_index];
                this.transfers[list_type][list_index].transfers.splice(transfer_index, 1);
                let previous_list_index = parseInt(list_index) - 1;
                let final_list;

                if (list_type === 'iban_swift' && transfer.currency === 'EUR' && previous_list_index < 0) {
                    let last_sepa = this.transfers.iban_sepa.length - 1;

                    final_list = this.transfers.iban_sepa[last_sepa];
                } else {
                    final_list = this.transfers[list_type][previous_list_index];
                }

                final_list.transfers.push(transfer);
                this.sortTransfers(final_list);
            } else {
                let transfer = this.transfers.rest[0].transfers[transfer_index];
                this.transfers.rest[0].transfers.splice(transfer_index, 1);
                this.moveTransfer(transfer);
            }

            this.clearTooltips();
        },
        moveTransfer: function(transfer) {
            let list_type = this.targetListType(transfer);
            //box "inne" zawsze przyjmuje do pierwszej listy, pozostale do ostatniej
            let index = list_type === 'other' ? 0 : this.transfers[list_type].length - 1;
            let final_list = this.transfers[list_type][index];

            final_list.transfers.push(transfer);
            this.sortTransfers(final_list);
        },
        movedown: function (list_type, list_index, transfer_index) {
            if (!this.transfers[list_type]) return;

            let next_list_index = parseInt(list_index) + 1;
            let transfer = this.transfers[list_type][list_index].transfers[transfer_index];
            this.transfers[list_type][list_index].transfers.splice(transfer_index, 1);

            let final_list;

            if (this.transfers[list_type][next_list_index] !== undefined) {
                final_list = this.transfers[list_type][next_list_index];
            } else if (list_type === 'iban_sepa' && transfer.currency === 'EUR') {
                final_list = this.transfers.iban_swift[0];
            } else {
                final_list = this.transfers.rest[0];
            }

            final_list.transfers.push(transfer);

            this.clearTooltips();
            this.sortTransfers(final_list);
        },
        clearTooltips: () => {
            $('div.tooltip[role="tooltip"]').remove();
        },
        //adres zrodlowego pliku wyznacza backend - skan, a w jego braku podglad XML
        downloadLink: function (url) {
            if (!url) return;

            window.location.href = url;
        },
        getListChecked: function (list_type, list_index) {
            let transfers = this.transfers[list_type][list_index].transfers;
            let checked = transfers.filter(t => t.checked === true);

            return checked.length === transfers.length;
        },
        changeListChecked: function (event, list_type, list_index) {
            let transfers = this.transfers[list_type][list_index].transfers;

            this.transfers[list_type][list_index].checked = event.target.checked;

            for (let transfer of transfers) {
                transfer.checked = event.target.checked;
            }
        },
        rowCheckedChange: function (list_type, list_index) {
            this.transfers[list_type][list_index].checked = this.getListChecked(list_type, list_index);
        },
        getContractorData: function (data, add_country = false) {
            let data_array = [data.name];

            if (data.address?.length) data_array.push(data.address);
            if (data.address_2?.length) data_array.push(data.address_2);
            if (data.zip?.length || data.city?.length) data_array.push(data.zip + ' ' + data.city);

            if (add_country) {
                data_array.push(data.country);
            }

            return data_array.join(', ');
        },
        getPlTaxName: function (data) {
            return data.name + ', ' + data.address
        },
        getTitleFromStatus: function (status) {
            switch (status) {
                case 'correct':
                    return 'correct_control_number'
                case 'incorrect':
                    return 'incorrect_control_number';
                default:
                    return 'no_verification_mechanism_for_chosen_template'
            }
        },
        accountChanged: function (account_number, list_type, list_index, transfer_index) {
            let transfer = this.transfers[list_type][list_index].transfers[transfer_index];
            let bankAccount = transfer.bank_accounts.find(acc => acc.account_number === account_number);

            transfer.account_number = account_number;
            transfer.account_number_status = bankAccount.account_number_status;
            transfer.swift = bankAccount.swift;
            transfer.transfer_type = bankAccount.account_type;
            transfer.bank_name = bankAccount.bank_name;

            //przenosimy dopiero gdy zmienia sie box - IBAN zaczynajacy sie od PL zostaje w boxie PL
            if (this.targetListType(transfer) !== list_type) {
                this.transfers[list_type][list_index].transfers.splice(transfer_index, 1);
                this.moveTransfer(transfer);
            }
        },
        /**
         * Wariant łączenia przelewu (Prz Połącz przelewy), null - przelewu nie można łączyć:
         * 1 - bez split payment i bez numeru KSeF,
         * 2 - bez split payment, z numerem KSeF, niepołączony (jedna pozycja źródłowa),
         * 3 - split payment, z numerem KSeF, niepołączony (dodatkowo wymagany ten sam NIP).
         */
        combineVariant: function (transfer) {
            if (!transfer.ksef_number) {
                return transfer.split_payment ? null : 1;
            }
            if ((transfer.sources || []).length !== 1) {
                return null;
            }

            return transfer.split_payment ? 3 : 2;
        },
        combineSelected: function () {
            let selected = this.selectedTransfers;
            let transfers = [];

            for (let type in selected) {
                for (let index in selected[type]) {
                    transfers = transfers.concat(selected[type][index]);
                }
            }

            if (!transfers.some(transfer => transfer.ksef_number)) {
                this.mergeSelected(selected);
                return;
            }

            if (transfers.length > 500) {
                Swal.fire({
                    text: this.__('ksef_collective_identifier_max_invoices'),
                    icon: 'warning',
                    confirmButtonColor: '#28a745',
                    confirmButtonText: this.$options.filters.capitalize(this.__('ok')),
                });
                return;
            }

            Swal.fire({
                html: this.__('ksef_collective_identifier_choose'),
                icon: 'warning',
                width: 700,
                customClass: {
                    htmlContainer: 'text-left',
                },
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonColor: '#28a745',
                denyButtonColor: '#28a745',
                confirmButtonText: this.__('generate_without_amounts'),
                denyButtonText: this.__('generate_with_amounts'),
                cancelButtonText: this.$options.filters.capitalize(this.__('cancel')),
            }).then(result => {
                if (!result.isConfirmed && !result.isDenied) return;

                this.generateCollectiveIdentifier(selected, transfers, result.isDenied ? 1 : 0);
            });
        },
        generateCollectiveIdentifier: function (selected, transfers, withAmounts) {
            toggleLoader(true);

            this.$store.dispatch(actions.GENERATE_KSEF_COLLECTIVE_IDENTIFIER, {
                with_amounts: withAmounts,
                transfers: transfers.map(transfer => ({
                    document_id: transfer.made_from_id,
                    amount: this.money.toFloat(transfer.amount),
                    currency: transfer.currency,
                })),
            }).then(response => {
                let preserved_transfer = this.mergeSelected(selected);
                //numer zbiorczy zastępuje numer KSeF połączonego przelewu (przy zapisie pełni jego funkcję)
                preserved_transfer.amount_blocked = withAmounts;
                preserved_transfer.ksef_number = response.data.number;
                toggleLoader(false);
            }).catch(error => {
                toggleLoader(false);
                let message = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : this.__('an_unexpected_error_has_occurred');
                Swal.fire({
                    text: message,
                    icon: 'warning',
                    confirmButtonColor: '#28a745',
                    confirmButtonText: this.$options.filters.capitalize(this.__('ok')),
                });
            });
        },
        /**
         * Standardowe łączenie zaznaczonych przelewów - zwraca przelew, w który połączono pozostałe.
         */
        mergeSelected: function (selected) {
            let merged_transfer;

            for (let type in selected) {
                if (!selected[type]) continue;

                for (let index in selected[type]) {
                    if (!selected[type][index]) continue;

                    let preserved_transfer;
                    let earliest_date;

                    let to_delete = [];

                    for (let [i, transfer] of selected[type][index].entries()) {
                        if (i === 0) {
                            preserved_transfer = transfer;
                            preserved_transfer.amount = this.money.toFloat(preserved_transfer.amount);
                            preserved_transfer.vat_amount = this.money.toFloat(preserved_transfer.vat_amount);
                            earliest_date = preserved_transfer.due_date;
                            continue;
                        }
                        preserved_transfer.amount += this.money.toFloat(transfer.amount);
                        //pozycje źródłowe zostają zachowane - potrzebne do rozbicia kwoty (IK Edytuj kwotę) i zapisu
                        preserved_transfer.sources = preserved_transfer.sources.concat(transfer.sources);
                        preserved_transfer.vat_amount += this.money.toFloat(transfer.vat_amount);
                        preserved_transfer.transfer_name += ', ' + transfer.transfer_name;
                        preserved_transfer.document_number += ', ' + transfer.document_number;
                        if (transfer.due_date < earliest_date) earliest_date = transfer.due_date;

                        to_delete.push(transfer.idx);
                    }

                    preserved_transfer.due_date = earliest_date;
                    preserved_transfer.amount = this.money.localize(preserved_transfer.amount);
                    preserved_transfer.vat_amount = this.money.localize(preserved_transfer.vat_amount);
                    for (let i = to_delete.length -1; i >= 0; i--) {
                        this.transfers[type][index].transfers.splice(to_delete[i], 1);
                    }
                    merged_transfer = preserved_transfer;
                }
            }

            return merged_transfer;
        },
        editContractor: function(contractor_id) {
            this.$store.commit(mutation_types.SET_TRANSFER_LISTS, this.transfers);

            let url = '/records/contractors/' + contractor_id + '/edit?' +
                'return=' + $('#current-url').val();

            window.location.href = url;
        },
        updateContractors: function() {
            let contractor_id = parseInt(this.contractor_id);
            if (contractor_id > 0) {
                for (let template in this.transfers) {
                    Object.keys(this.transfers[template]).forEach((key) => {
                        for (let transfer of this.transfers[template][key].transfers) {
                            if (parseInt(transfer.contractor.id) === contractor_id) {
                                transfer.contractorState = this.updated_contractor;
                                transfer.contractor = this.updated_contractor;
                            }
                        }
                    })
                }
            }
        },
        checkForm: function () {
            let errors = false;

            for (let type in this.transfers) {
                if (type === 'rest') continue;

                for (let list of this.transfers[type]) {
                    list.errors.due_date = false;
                    list.errors.account = false;
                    list.errors.description = false;

                    if (!list.transfers.length) continue;

                    if (list.due_date === null || list.due_date === "") {
                        list.errors.due_date = true;
                        errors = true;
                    }
                    if (list.account_number === null) {
                        list.errors.account = true;
                        errors = true;
                    }
                    if (list.description == null || list.description.trim() === "") {
                        list.errors.description = true;
                        errors = true;
                    }
                    else if(list.description.length > 50){
                        list.errors.description = true;
                        errors = true;
                    }
                }
            }
            if($('.tittle-error').length > 0){
                errors = true;
            }

            return errors;
        },
        saveLists: function () {
            let check = this.checkForm();

            if (check) {
                toastr["error"](this.__("fill_all_required_fields_before_saving_lists")).css(
                    "border",
                    "0px"
                );

                return;
            }

            this.$store.dispatch(actions.SAVE_LISTS, this.transfers).then(response => {
                if (response?.data?.url) window.location.href = response.data.url;
            });
        },
        removeList: function (list_type, list_index) {
            if (this.transfers[list_type][list_index].transfers.length > 0) return;

            this.transfers[list_type].splice(list_index, 1);
        },
        addList: function (list_type) {
            this.transfers[list_type].push(this.emptyList())
        },
        confirmDatePicker: async function (date, list) {
            let ask = false;
            list.due_date = date;

            for (let transfer of list.transfers) {
                if (transfer.due_date < date) {
                    ask = true;
                    break;
                }
            }

            if (ask) {
                this.$swal({
                    title: this.__("warning_!"),
                    html: this.__('chosen_date_is_later_than_due_date_please_confirm'),
                    icon: "warning",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    confirmButtonText: this.$options.filters.capitalize(this.__("ok")),
                    cancelButtonText: this.$options.filters.capitalize(this.__("cancel")),
                    closeOnConfirm: true,
                    reverseButtons: true
                }).then(result => {
                    if (result.value !== true) {
                        list.due_date = null;
                    }
                });
            }
        },
        listCount: function (type) {
            return Object.keys(this.transfers[type]).length;
        },
        idNotAllowed: function (transfer) {
            return (!this.allowed_id_numbers.pl.find(n => n === transfer.id_number_id) && transfer.split_payment);
        },
        hasTransfers: function (list_type) {
            return (list_type.length > 1 || list_type[0].transfers.length > 0)
        },
        setSort: function (list, sort_col) {
            if (list.sort_col === sort_col)  {
                list.sort_dir = list.sort_dir === 'asc' ? 'desc' : 'asc';
            } else {
                list.sort_dir = 'asc';
            }
            list.sort_col = sort_col;

            this.sortTransfers(list);
        },
        sortTransfers: function (list) {
            list.transfers.sort((a, b) => {
                let value_a, value_b;

                switch (list.sort_col) {
                    case 'contractor_data':
                        value_a = this.getContractorData(a.contractorState);
                        value_b = this.getContractorData(b.contractorState);
                        break;
                    case 'form_symbol':
                        value_a = a.pl_tax_data.symbol;
                        value_b = b.pl_tax_data.symbol;
                        break;
                    case 'period':
                        value_a = this.getFullPeriod(a.pl_tax_data);
                        value_b = this.getFullPeriod(b.pl_tax_data);
                        break;
                    case 'liability_id':
                        value_a = a.pl_tax_data.period_identification_title;
                        value_b = b.pl_tax_data.period_identification_title;
                        break;
                    case 'payer_data':
                        value_a = this.getPlTaxName(a.pl_tax_data);
                        value_b = this.getPlTaxName(b.pl_tax_data);
                        break;
                    case 'payer_identificator':
                        value_a = this.getFullPlTaxID(a.pl_tax_data);
                        value_b = this.getFullPlTaxID(b.pl_tax_data);
                        break;
                    default:
                        value_a = a[list.sort_col];
                        value_b = b[list.sort_col];
                }
                let result = value_a < value_b ? -1 : 1;

                if (list.sort_dir === 'desc') {
                    result *= -1;
                }

                return result;
            });
        },
        sortLists: function () {
            for (let list_type in this.transfers) {
                for (let list of this.transfers[list_type]) {
                    this.sortTransfers(list);
                }
            }
        }
    },
    computed: {
        availableAccountsPl: function () {
            return this.availableAccounts.filter((acc) => {
                return acc.details.template_code === "pl";
            });
        },
        selectedTransfers: function () {
            let selected = {};
            for (let [i, list] of this.transfers.pl.entries()) {
                let checked = list.transfers.map((t, i) => {t.idx = i; return t;}).filter(t => t.checked);
                if (checked.length) selected.pl = {[i]: checked};
            }
            for (let [i, list] of this.transfers.iban_sepa.entries()) {
                let checked = list.transfers.map((t, i) => {t.idx = i; return t;}).filter(t => t.checked);
                if (checked.length) selected.iban_sepa = {[i]: checked};
            }
            for (let [i, list] of this.transfers.iban_swift.entries()) {
                let checked = list.transfers.map((t, i) => {t.idx = i; return t;}).filter(t => t.checked);
                if (checked.length) selected.iban_swift = {[i]: checked};
            }
            for (let [i, list] of this.transfers.other.entries()) {
                let checked = list.transfers.map((t, i) => {t.idx = i; return t;}).filter(t => t.checked);
                if (checked.length) selected.other = {[i]: checked};
            }

            return selected;
        },
        combineDisabled: function () {
            for (let list of this.transfers.pl_tax) {
                let checked = list.transfers.filter(t => t.checked);
                if (checked.length) return true;
            }

            let selected = this.selectedTransfers;

            if (Object.keys(selected).length !== 1) return true;

            for (let type in selected) {
                if (Object.keys(selected[type]).length !== 1) return true;

                for (let index in selected[type]) {
                    if (selected[type][index].length < 2) return true;

                    let oldTransfer;
                    let variant;
                    for (let transfer of selected[type][index]) {
                        //wszystkie zaznaczone przelewy muszą spełniać ten sam wariant łączenia
                        let transferVariant = this.combineVariant(transfer);
                        if (!transferVariant) return true;
                        //przelewy z IK "e" (warianty 2 i 3) - wymagane zapisane parametry łączenia z KSeF
                        if (transferVariant !== 1 && this.ksef_connection_params_saved != 1) return true;
                        if (variant && variant !== transferVariant) return true;
                        variant = transferVariant;

                        if (oldTransfer) {
                            if (oldTransfer.currency !== transfer.currency) return true;
                            if (oldTransfer.account_number !== transfer.account_number) return true;
                            if (this.getContractorData(oldTransfer.contractorState) !== this.getContractorData(transfer.contractorState)) return true;
                            if (transfer.split_payment && oldTransfer.id_number !== transfer.id_number) return true;
                        }
                        oldTransfer = transfer;
                    }
                }
            }

            return false;
        },
        saveDisabled: function () {
            for (let list of this.transfers.pl) {
                for (let transfer of list.transfers) {
                    if (this.idNotAllowed(transfer))
                        return true;
                }
            }

            return false;
        },
        updated_contractor: function () {
            return JSON.parse(this.new_contractor);
        }
    },
    mounted: function () {
        for (let type in this.transfers) {
            this.transfers[type].push(this.emptyList())
        }

        const oldTransfers = this.$store.getters.getTransferLists;

        if (Object.keys(oldTransfers).length === 0) {
            toggleLoader()
            this.$store.dispatch(actions.FETCH_TRANSFERS_FOR_LIST)
                .then(response => {
                    let transfers = response.data.data;

                    this.siftTransfers(transfers);
                    toggleLoader(false)
                });
        } else {
            this.transfers = oldTransfers;
            this.$store.commit(mutation_types.CLEAR_TRANSFER_LISTS);
            this.updateContractors();
            toggleLoader(false)
        }

        this.allowed_id_numbers = JSON.parse(this.allowed_id_number_types);

        this.availableAccounts = JSON.parse(this.paymentSources);
    },

}
</script>

<style scoped>
/* belki poszczególnych list w kolorze belki głównej (.ibox-grey), żeby listy się nie zlewały */
.row-grey {
    padding-top: 5px;
    padding-bottom: 5px;
    background-color: #495966;
    color: #fff;
}

.row-grey h4,
.row-grey h5 {
    color: #fff;
}

.ibox-content.ibox-transfer {
    padding-top: 0;
    padding-bottom: 3px;
}

.table-transfers .form-control, .table-transfers select.form-control:not([size]):not([multiple]), .table-transfers .input-group-addon {
    font-size: 11px;
    height: 24px;
}

select.form-control:not([size]):not([multiple]) {
    height: 30px;
}

.form-control, .single-line {
    font-size: 12px;
    padding: 1px 6px;
    transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
    /*width: 100%;*/
    border: 1px solid #c9ccd0;
}

.input-group-addon {
    border: 1px solid #c9ccd0;
    font-size: 16px;
    padding: 6px 12px 4px 12px;
}

/* pelny NRB (26 cyfr) ma byc widoczny - bez tego kolumna zgniatala select do kilku znakow */
.table-transfers .nrb-select {
    min-width: 210px;
}
</style>

<style>
.swal2-content {
    font-size: 16px;
    font-weight: 300;
}
button.swal2-styled {
    padding: 5px 15px;
}
</style>
